
const X5 = {
  header: {
    category: "Panoráma Röntgen",
    model: "MyRay X5",
    tagline: "Kompakt, rugalmas és minden diagnosztikai igény kielégítésére tervezték.",
  },

  hero: {
    image: "/uploads/x5.png",
    buttonText: "Digitális bemutatóterem",
    title: "MyRay X5",
    description:
      "A Hyperion X5 a világ egyik legkisebb felfüggesztett 3D/2D képalkotó rendszere, amelyet a rugalmasság és a könnyű használhatóság maximalizálására terveztek bármely fogászati ​​rendelőben.",
    showroom: "https://www.vitshowroom.it/interactive/myray/index.php?IDmodello=1074&param=sala1,162.94,-6.55,94.80,4,ENG"
  },

  description: {
    title: "Jellemzők",
    columns: [
      [
        "Könnyen telepíthető",
        "Időben tartó megbízhatóság",
        "Automatikus moduláció",
      ],
      [
        "Minden igényt kielégít",
        "Könnyű vezérlés.",
        "Korszerű dizájn"
      ],
    ],
    image: "/uploads/x5-pano.jpg",
  },

  sections: [
    {
      title: "Tulajdonságok",
      cards: [
        {
          title: "Korszerű dizájn",
          description: "Könnyű, minimalista kialakításának köszönhetően a falra szerelhető rendszer könnyedén beépíthető bármilyen rendelőbe, optimalizálva a helykihasználást és leegyszerűsítve a telepítést a nagy teljesítmény feláldozása nélkül. Moduláris, bővíthető konfigurációjának köszönhetően a rendelő növekedésével együtt bővíthető.",
        },
        {
          title: "Minden igényt kielégít",
          description: "A MultiPAN funkcióval ellátott 2D digitális panorámaképalkotástól a nagyfelbontású 3D volumetrikus képalkotásig a Hyperion X5 számos klinikai vizsgálatot tesz lehetővé, beleértve a kefalometriai és arcüreg-vizsgálatokat is. Kivételes rugalmasságának köszönhetően mind a standard, mind a haladó vizsgálatokhoz alkalmas, a látómező pedig a speciális szakorvosi igényekhez igazítható.",
        },
      ],
    },
    {
      title: "Optimalizált munkafolyamat",
      cards: [
        {
          title: "Virtuális vezérlőpult",
          description: "A Hyperion X5 leegyszerűsíti a diagnosztika minden szakaszát. A munkafolyamatok gördülékenyek és felhasználóbarátak az idő optimális kihasználása és a pontosság biztosítása érdekében. A funkciók iPaden vagy a számítógép virtuális kezelőpaneljén keresztül vezérelhetők. A felhasználók kényelmesen kezelhetik a szkenneléseket és a beállításokat a táblagépről vagy a munkaállomásról a felhasználóbarát felületeken keresztül, amelyek gyors hozzáférést biztosítanak az összes funkcióhoz.",
        },
        {
          title: "Irányított pozicionálás",
          description: "A lézeres követésen alapuló irányított pozicionálás biztosítja a páciens helyes pozicionálását, kényelmet és precizitást biztosítva minden vizsgálat során. A szervovezérelt Scout View rendszer – amely értékes segédeszköz a vizsgált terület precíz beállításához – rendkívül alacsony sugárterheléssel készült sagittális és frontális képeket jelenít meg. A vizsgálati terület közvetlenül a számítógépről módosítható az optimális eredmények elérése érdekében.",
        },
        {
          title: "Ultra alacsony dózisú gyors vizsgálat",
          description: "Advanced protocols such as QuickScan can be used to make fast yet detailed scans with minimal X-ray doses, safeguarding both patient health and image quality. These scans are highly suitable for fast diagnoses and surgical follow-ups.",
        },
      ],
    },
    {
      title: "A 2D szkennelés legjava",
      cards: [
        {
          title: "MRT technológia",
          description: "A PAN-szkennelések MRT-t (morfológiafelismerő technológiát) használnak az expozíciós paraméterek automatikus hozzáigazításához a páciens morfológiájához, az iPAN protokollt pedig a kiváló minőségű panorámaképek automatikus előállításához. Egy élvonalbeli algoritmus választja ki a legjobb fókuszt.",
        },
        {
          title: "PAN, TMJ és SIN szkennelések",
          description: "A PAN szkennelésekkel nagy ortogonalitású panorámaképeket készíthet, míg a MultiPAN funkció, amely különböző fókuszrétegeket generál, lehetővé teszi a legjobb kiválasztását. Az állkapocsízület szkennelései laterális és frontális vetülettel is elérhetők a teljes kép érdekében. Az arcüregszkennelés tiszta, részletes képet ad a maxilláris arcüregekről az orr- és arcüregpatológiák pontos diagnosztizálásához.",
        },
      ],
    },
    {
      title: "A 3D minden lehetősége",
      cards: [
        {
          title: "3D fejtámasz",
          description: "3D fejtámasz 5 érintkezési ponttal: biztosítja a beteg helyes pozicionálását, javítja a stabilitást a vizsgálat során, és pontos, konzisztens diagnosztikai eredményeket biztosít.",
        },
        {
          title: "Széles látómezőtartomány",
          description: "Válassza ki a legmegfelelőbb látómezőt a rendelkezésre álló látómezők közül (10x10, 10x6, 10x7, 8x6, 8x7, 6x6, 6x7 cm), hogy a vizsgálatot az adott anatómiai területhez igazítsa, optimalizálva a képminőséget és minimalizálva a röntgensugár-dózist.",
        },
        {
          title: "Széles látómezőtartomány",
          description: "Válassza ki a legmegfelelőbb látómezőt a rendelkezésre álló látómezők közül (10x10, 10x6, 10x7, 8x6, 8x7, 6x6, 6x7 cm), hogy a vizsgálatot az adott anatómiai területhez igazítsa, optimalizálva a képminőséget és minimalizálva a röntgensugár-dózist.",
        },
      ],
    },
  ],
};

export default X5;